<template>
  <!-- <a-locale-provider :locale="locale"> -->
    <div id="app">
        
            <div class="loadingBox" v-if="this.$store.state.loadding">
              <a-spin :spinning="this.$store.state.loadding" :indicator="indicatorText">
              </a-spin>
            </div>
        
      <router-view/>
    </div>
  <!-- </a-locale-provider> -->
</template>
<script>
// import enGB from 'ant-design-vue/lib/locale-provider/en_GB';
export default {
  components: {
  },
  name: "App",
  data() {
    return {
      // locale: enGB,
      indicatorText: <a-icon type="loading" style="font-size: 100px" spin />,
    };
  },
  props: {},
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created() {
   
  },
  mounted() {
    
  },
  destroyed() {}
};
</script>
<style lang="less">
@import '~ant-design-vue/dist/antd.less'; 
@primary-color: #D8000F;
@import './style/common';
@import './style/ant-reset';

// /deep/ .ant-input {
//   border-radius: 50px;
// }
a{
  &:focus{
    outline: -webkit-focus-ring-color auto 1px;
    outline-color: -webkit-focus-ring-color;
    outline-style: auto;
    outline-width: 1px;
  }
}
.loadingBox{
  position: fixed;
  text-align: center;
  line-height: 100vh;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
  left: 0;
  top: 0;
  z-index: 999;
}
.ant-switch-disabled, .ant-switch-disabled::after{
  cursor: pointer;
  opacity: 1;
}
</style>
